import './bootstrap';
import '../css/app.css';

import { createApp } from 'vue'; // Import Vue 3's createApp function
import OrganizePdf from './Components/OrganizePdf.vue';

const app = createApp({
    components: {
        OrganizePdf

    },

});
app.mount('#app');
